import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store'

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (!store.getters["auth/authenticated"]) {
    if(to.matched.some(record => record.meta.requiresAuth)) {
      next('/login')
      return
    }
  } else if(to.name === 'login') {
    next('/dashboard')
    return
  }
  next()
})

export default router;
